<template>
    <Dashboard
        :title="__('Create file', null, $page.props.profile_locale)"
    >
        <Heading
            :label="'Create file'"
            :description="'<span class=\'text-red-700\'>' + product.name + '</span>'"
            :backLink="route('dashboard.admin.product.downloads', product.id)"
        />

        <div class="grid grid-cols-2 gap-3">
            <InputLabel
                id="name"
                :label="__('File name', null, $page.props.profile_locale)"
                class="col-span-2 "
                v-model="form.name"
            />

            <div class="col-span-2">
                <label for="file" />
                <input id="file" type="file" @change="ev => { form.file = ev.target.files[0]; $page.props.errors.file = null}">
                <div
                    v-if="checkError($page.props.errors, 'file')"
                    class="text-red-500 text-xs font-bold"
                >{{checkError($page.props.errors, 'file')}}</div>
            </div>

            <div class="col-span-2 flex justify-start">
                <Button
                    color="gray"
                    padding="md"
                    @click="save()"
                >
                {{__('Save', null, $page.props.profile_locale)}}
                </Button>
            </div>
        </div>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import Heading from 'COMP/Heading';
import InputLabel from 'UI/InputLabel';
import Button from 'UI/Button';

import { useForm } from '@inertiajs/inertia-vue3';

import {
    checkError
} from 'helper';

export default {
    components: {
        Dashboard,
        Heading,
        InputLabel,
        Button
    },
    props: ['product', 'question'],
    setup(props) {

        const form = useForm({
            name: null,
            file: null,
            product_id: props.product.id,
        });


        function save() {
            form.post(route('product.download.store'), {
                preserveScroll: true,
                onSuccess: () => form.reset(),
            })
        }

        return {
            form,

            save,
            checkError
        }
    }
}
</script>

<style>

</style>
